import { useTranslations } from "next-intl";
import React from "react";

type Props = {
  hostname: string;
  reply: string;
};

const ReplyComment = ({ hostname, reply }: Props) => {
  const t = useTranslations();

  return (
    <div className="bg-green-background space-y-3 p-4 rounded-2xl">
      <span className="text-gray-light">
        {t("replyComment.host", { hostname })}
      </span>
      <p className="text-gray-dark">{reply}</p>
    </div>
  );
};

export default ReplyComment;
